import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export default class ReferralStatusView extends Enum {
  value!: string;
  color!: string;
  updatedColor!: string;
  updatedValue!: string;

  public static INVITED: ReferralStatusView = {
    get value() {
      return Lang.t('team.invited');
    },
    get updatedValue() {
      return Lang.t('referral.referred');
    },
    color: '#FF865B',
    updatedColor: '#1305b8'
  };

  public static NOT_INVITED: ReferralStatusView = {
    get value() {
      return Lang.t('referral.not-invited');
    },
    get updatedValue() {
      return Lang.t('referral.not-referred');
    },
    color: '#7E84A3',
    updatedColor: '#7E84A3'
  };

  public static ACTIVE: ReferralStatusView = {
    get value() {
      return Lang.t('inbox.active');
    },
    get updatedValue() {
      return Lang.t('inbox.active');
    },
    color: '#60C49D',
    updatedColor: '#60C49D'
  };
}
